export class ConfirmDialog {
  titulo;
  message = '-';
  submessage = '';
  labelCancel = 'Cancelar';
  labelOk = 'Confirmar';
  // fnOK: object;
  flagRespuesta = false;
}
